<template>
  <!-- Role Seçim Ekranı -->
  <div v-if="!roleType" class="auth-wrapper login-container d-flex align-items-center justify-content-center h-100 w-100">
    <div>
        <div class="role-grid">
          <b-card class="text-center role-card" @click="changeRole('influencer')">
            <feather-icon icon="InstagramIcon" size="25" />
            <b-card-title class="mt-2 mb-0">Fenomen Girişi</b-card-title>
          </b-card>

          <b-card class="text-center role-card" @click="changeRole('admin')">
            <feather-icon icon="AwardIcon" size="25" />
            <b-card-title class="mt-2 mb-0">Marka Girişi</b-card-title>
          </b-card>

          <b-card class="text-center role-card role-card-full" @click="changeRole('agency')">
            <feather-icon icon="BriefcaseIcon" size="25" />
            <b-card-title class="mt-2 mb-0">Ajans Girişi</b-card-title>
          </b-card>
        </div>
    </div>
  </div>
  <div class="auth-wrapper auth-v2" v-else>
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo /> -->
        <h2 class="brand-text text-primary ml-1">
          Fenomany
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <transition name="fade">
            <b-card-title
              title-tag="h2"
              class="font-weight-bold mb-1"
              key="title"
            >
              Hoşgeldiniz 👋 
            </b-card-title>
          </transition>
          <transition name="fade" v-if="!isDeveloper">
            <b-card-text class="mb-2" key="subtitle">

              {{ isAgency ? 'Ajans' : (isFenomen ? 'Fenomen' : 'Marka') }} girişi ekranı

            </b-card-text>
          </transition>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >

            <b-form-group v-if="isDeveloper" label="Kullanıcı Adı" label-for="login-username">
              <validation-provider #default="{ errors }" name="Kullanıcı Adı" rules="required">
                <b-form-input
                  id="login-username"
                  v-model="username"
                  :state="errors.length > 0 ? false : null"
                  name="login-username"
                  placeholder="Kullanıcı adınızı giriniz"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

              <!-- email -->
              <b-form-group
                v-if="!isDeveloper"
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Şifre</label>
                  <router-link :to="{ name: 'forgot-password', params: { type: roleType } }" v-if="!isDeveloper">
                    <small>Şifremi Unuttum?</small>
                  </router-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group v-if="!isDeveloper">
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Beni Hatırla
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                @click="validationForm"
              >
                Giriş Yap
              </b-button>
            </b-form>
          </validation-observer>
          <p class="text-center mt-2">
            <b-link @click="deleteRole">
              <feather-icon icon="ChevronLeftIcon" />
              Giriş seçenekleri
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>

    <b-modal
      v-model="modalShow"
      title="Firma Seçiniz"
      centered 
      hide-footer
      modal-class="modal-success" 
    >
      <div class="row justify-content-center">
        <div class="px-2 py-1" v-for="customer in customerList" :key="customer" @click="selectCustomer(customer)">
            <b-button variant="gradient-danger">{{ customer.domain }}</b-button>
        </div>
      </div>
    </b-modal>

  </div>
</template>


<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol,BCard, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton,BModal
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BModal,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BCard,
    BCardTitle,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      username:'',
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rulesimport store from '@/store/index'
      required,
      modalShow:false,
      customerList:[],
      roleType : this.$route.params.type ? this.$route.params.type : null
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
    isDeveloper(){
      return this.roleType == 'developer'
    },
    isAdmin(){
      return this.roleType == 'admin'
    },
    isFenomen(){
      return this.roleType == 'influencer'
    },
    isAgency(){
      return this.roleType == 'agency'
    }
  },
  mounted() {
  },
  methods: {
    deleteRole(){
      this.$router.replace({ path: '/login'})
      this.roleType=null
    },
    changeRole(role){
      this.roleType=role
      this.$router.replace({ path: '/login/'+role })
    },
    selectCustomer(customer) {
      this.modalShow = false; // Modalı kapat
      const url = '/auth/login'

      this.$store.commit('user/SET_CUSTOMER', customer); // Müşteri bilgilerini kaydet

      this.$http.post(url, {
        email: this.userEmail,
        password: this.password,
        multilogin: true,
        user_type : this.roleType
      })
      .then(response => {
        if (response.data.success) {
          const userData = response.data.userData;
          this.$store.commit('user/SET_LOGIN', response.data);
          this.$router.replace({ path: '/' })
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Hoşgeldin ${userData.name_surname}`,
                  icon: 'SmileIcon',
                  variant: 'success',
                },
              });
            });
        } else {
          this.$toast.error(response.data.message || 'Giriş başarısız.');
          this.$store.commit('user/SET_CUSTOMER', null);
        }
      })
      .catch(error => {
        this.$toast.error('Sunucu Hatası: ' + (error.response?.data?.message || error.message || 'Bilinmeyen hata'));
      });
    },

    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          let url = '/auth/login'
          const data = { password: this.password }; // Gönderilecek veri

          if (this.isDeveloper) {
            url = '/auth/manageLogin'; // Developer login endpoint'i
            data.username = this.username; // Developer için username ekle
          } else {
            data.email = this.userEmail;
            data.user_type = this.roleType == 'influencer' ? 'influencer' : 'admin'
          }

          this.$http.post(url, data)
            .then(response => {
              if (response.data.success) {
                const userData = response.data.userData;
                this.$store.commit('user/SET_LOGIN', response.data);
                this.$store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', false);
                this.$router.replace({ path: '/' })
                  .then(() => {
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-right',
                      props: {
                        title: `Hoşgeldin ${userData.name_surname}`,
                        icon: 'SmileIcon',
                        variant: 'success',
                      },
                    });
                  });
              } else if (response.data.selectCustomer) {
                // Eğer müşteri seçimi gerekiyorsa, modal'ı göster
                this.modalShow = true;
                this.customerList = response.data.customers;
              } else {
                // Hata mesajını göster
                this.$toast.error(response.data.error || 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
              }
            })
            .catch(error => {
              // Sunucu hatası veya ağ hatası durumunda hata mesajı
              this.$toast.error('Sunucu Hatası: ' + (error.response?.data?.message || error.message || 'Bilinmeyen hata'));
            });
        }
      });
    },

  },
  watch: {
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-auth.scss';


      .role-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1.5rem; /* İsteğe göre 20px / 24px ayarlanabilir */
      }

      /* b-card'ın varsayılan margin-bottom değerini eziyoruz */
      .role-card {
        margin-bottom: 0 !important;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
      }

      .role-card:hover {
        transform: translateY(-2px);
        background-color: #f8f9fa; /* İsteğe göre hover arka plan rengi */
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* İsteğe göre hover gölge efekti */
        color: #000;
      }

      /* Alttaki Ajans Girişi kartı iki kolonu birden kaplar */
      .role-card-full {
        grid-column: span 2;
      }
</style>
